<template>
    <rkm-modal
        extra-large
        persistent
        ref="RkmModal"
        title="Log de operações"
    >
        <rkm-row>
            <rkm-col>
                <rkm-table
                    :fields="fields"
                    :items="items"
                    ref="RkmTable"
                />
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{cancel}">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({loading: 'getLoading'}),
    },
    created() {
        this.repositories = {
            tabelaObm: this.getConectaSusRepository('parametrizacao.tabelaObm'),
        }
    },
    data: () => ({
        fields: [
            {key: 'dataHora', label: 'Data / Hora', sortable: true},
            {key: 'operacaoNome', label: 'Operação', sortable: true},
            {key: 'materialDescricao', label: 'Material', sortable: true},
            {key: 'usuarioNome', label: 'Usuário', sortable: true},
        ],
        items: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(id) {
            this.reset()

            this.show(id)

            this.$refs.RkmModal.show()
        },
        show(id) {
            this.setLoading()

            this.repositories.tabelaObm.show(id)
                .then(response => this.items = response.data.log)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.items = []
        },
    },
    mixins: [error, repository],
}
</script>